import { RenewFileboxRecordDto } from '../dtos/renew-filebox-record.dto';

/**
 * Renew filebox records response DTO
 */
export class RenewFileboxRecordsResponse {
	records!: RenewFileboxRecordDto[];
}
